import { tokens } from '@usepepper/sprout-kit';

export const PAR_COLUMN_WIDTH = 40;

// Named portal host scoping the selection toolbar to the content panel (so it
// floats within the panel rather than the full window past the sidebar).
export const ORDER_GUIDE_PANEL_PORTAL_HOST = 'OrderGuidePanelPortalHost';

// Named portal host in the top bar's actions slot
export const ORDER_GUIDE_HEADER_ACTIONS_PORTAL_HOST =
  'OrderGuideHeaderActionsPortalHost';

// Height of an item row's header line
export const ITEM_HEADER_ROW_HEIGHT = 62;

// Editable rows carry a trailing gap + drag handle (see SortableListItem): row
// gap + grip icon + handle padding each side. Reserve the same width so the Par
// column lines up across the header, rows, and skeleton.
export const DRAG_HANDLE_RESERVE =
  tokens.spacing.spaceLarge +
  tokens.spacing.spaceMedium +
  tokens.spacing.spaceXsmall * 2;
